import React, { useEffect } from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import BackButton from '../../../components/BackButton'
import { useLocation, useNavigate } from 'react-router-dom'
import hours from '../../../contants/hours'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import swal from 'sweetalert'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { Helmet } from 'react-helmet'

function UpdateHoliday() {
    let { state } = useLocation()
    const updateForm = useForm()
    const navigate = useNavigate();

    console.log("state", state)

    const { token } = useSelector((state) => state.auth)

    const fillForm = () => {
        console.log("fill form çalıştı")
        if (state) {
            updateForm.setValue('id', state?.holiday?.id)
            updateForm.setValue('date', state?.holiday?.date)
            updateForm.setValue('allDay', state?.holiday?.allDay)
            updateForm.setValue('openTime', moment(state?.holiday?.openTime, 'HH:mm').format('HH:mm'))
            updateForm.setValue('closeTime', moment(state?.holiday?.closeTime, 'HH:mm').format('HH:mm'))
        }
    }

    console.log("updateForm", updateForm.watch())

    useEffect(() => {
        fillForm()
    }, [state, updateForm])

    const updateSubmit = (data) => {
        data.openTime = moment(data.openTime, 'HH:mm').format('HH:mm')
        data.closeTime = moment(data.closeTime, 'HH:mm').format('HH:mm')

        axios.put(`${process.env.REACT_APP_SERVICE_URL}/holiday`, {
            id: data.id,
            date: data.date,
            allDay: data.allDay,
            openTime: data.openTime,
            closeTime: data.closeTime
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log("updateSubmit", response)
                swal("Tatil başarıyla güncellendi", {
                    icon: "success",
                });
                //navigate(-1)
            })
            .catch((error) => {
                console.error("updateSubmit", error)
                swal("Tatil güncellenirken bir hata oluştu", {
                    icon: "error",
                });
            })

    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Tatil Güncelle</title>
                <meta name='description' content='Tatil Güncelle' />
            </Helmet>
            <HeaderTitle title='Tatil Güncelle' description={'Tatil güncelleme sayfası'} />

            <div className='row'>
                <div className='col-md-4'>
                    <div className='card card-body'>
                        <BackButton />

                        <form className='mt-3' onSubmit={updateForm.handleSubmit(updateSubmit)}>
                            <div className='mb-3'>
                                <label className='form-label'>Tarih</label>
                                <input
                                    type='date'
                                    name='date'
                                    defaultValue={updateForm.watch("date")}
                                    className='form-control'
                                    onChange={(e) => updateForm.setValue('date', e.target.value)}
                                    min={new Date().toISOString().split('T')[0]} />
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Tüm Gün</label>
                                <select
                                    name='allDay'
                                    defaultValue={updateForm.watch("allDay")}
                                    onChange={(e) => updateForm.setValue('allDay', e.target.value)}
                                    className='form-select'>
                                    <option value={true}>Evet</option>
                                    <option value={false}>Hayır</option>
                                </select>
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Başlangıç Saati</label>
                                <select name='openTime'
                                    value={updateForm.watch("openTime")}
                                    onChange={(e) => updateForm.setValue('openTime', e.target.value)}
                                    className='form-select'>
                                    {
                                        hours.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })
                                    }
                                </select>
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Bitiş Saati</label>
                                <select name='closeTime'
                                    value={updateForm.watch("closeTime")}
                                    onChange={(e) => updateForm.setValue('closeTime', e.target.value)}
                                    className='form-select'>
                                    {
                                        hours.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })
                                    }
                                </select>
                            </div>

                            <div className=''>
                                <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateHoliday